module.exports = __webpack_public_path__ + "static/img/30.a353b85.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/30.jpg
// module id = 0X7u
// module chunks = 1